import { useMemo } from 'react'
import { User } from '@weblite/ts-action/user'
import { ProfileInfoItem } from '$common/profile-info-item'
import { ProfileInfoParser } from '$common/profile-info-parser'
import { showCopyMenu } from '$comp/modals/menus/copy-menu'
import { showPhoneMenu } from '$comp/modals/menus/phone-menu'
import {
  showBioSavedInMemorySnackbar,
  showTextSavedInMemorySnackbar,
  showUsernameSavedInMemorySnackbar,
} from '$comp/snackbars'
import { useIsClientUserSupport } from '$logic/client-user'
import { toHumanReadablePhone } from '$func/phone'
import { SHOW_USER_INFO_TO_SUPPORT } from '$func/environmentInfo'
import { t } from '$i18n'

interface Prop {
  user: User
}

export function UserProfileInfo({ user }: Prop) {
  const { phone, username, bio, id } = user
  const isClientUserSupport = useIsClientUserSupport()

  const showUserInfo = isClientUserSupport && SHOW_USER_INFO_TO_SUPPORT

  const readablePhone = useMemo(() => {
    return toHumanReadablePhone(phone) || ''
  }, [phone])

  if (!(username || bio || phone || showUserInfo)) return null
  return (
    <>
      {phone && (
        <ProfileInfoItem
          value={readablePhone}
          label={t('user.phone')}
          onClick={e => {
            showPhoneMenu({
              phone: readablePhone,
              clientX: e.clientX,
              clientY: e.clientY,
              showAppOptions: false,
            })
          }}
        />
      )}

      {showUserInfo && (
        <ProfileInfoItem
          onClick={() =>
            showCopyMenu({
              text: id,
              onDone: showTextSavedInMemorySnackbar,
            })
          }
          label={t('user.id')}
          value={id}
        />
      )}

      {bio && (
        <ProfileInfoParser
          value={bio}
          label={t('user.bio')}
          onClick={() =>
            showCopyMenu({
              text: bio,
              onDone: showBioSavedInMemorySnackbar,
            })
          }
        />
      )}

      {username && (
        <ProfileInfoItem
          value={`@${username}`}
          label={t('user.username')}
          onClick={() =>
            showCopyMenu({
              text: username,
              onDone: showUsernameSavedInMemorySnackbar,
            })
          }
        />
      )}
    </>
  )
}
